var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated_logo"},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"width":180},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/AnimatedLogo.vue